import { createElement } from './globalFunctions'

/**
 * Move cart header to the top of the cart content
 */
const moveCartHeader = () => {
	const pageHeader = document.querySelector('#header')
	const content = document.querySelector('#content')
	const cartHeader = document.querySelector('.cart-content .cart-header')
	const cartHeaderHelper = document.querySelector('.cart-header-wrapper')
	if (cartHeader && !cartHeaderHelper) {
		const cartHeaderWrapper = createElement('div', ['cart-header-wrapper'])
		cartHeaderWrapper.appendChild(cartHeader)
		cartHeader.classList.add('container')
		// content.prepend(cartHeaderWrapper)
		pageHeader.parentElement.insertBefore(cartHeaderWrapper, pageHeader.nextElementSibling)
	} else if (cartHeader && cartHeaderHelper) {
		cartHeader.remove()
	}
}

const summaryWrapper = document.querySelector('.summary-wrapper')
/**
 * Move extra delivery to the sidebar
 */
const moveExtraDeliveryToSidebar = () => {
	const sidebarInCart = document.querySelector('.sidebar-in-cart')

	const extraDelivery = document.querySelector('.extra.delivery')
	// if (!extraDelivery || !summaryWrapper) return
	if (!extraDelivery || !sidebarInCart) return

	sidebarInCart.prepend(extraDelivery)
}

/**
 * Move coupon field to the sidebar
 */
const moveCouponFieldToSidebar = () => {
	const couponField = document.querySelector('.discount-coupon')
	if (!couponField || !summaryWrapper) return
	summaryWrapper.prepend(couponField)
}

/**
 * Create a cart footer and append it to the DOM
 * @returns {HTMLElement} cartFooter - The cart footer element that was created and appended to the DOM
 */
const createCartFooter = () => {
	const overallWrapper = document.querySelector('.overall-wrapper')
	if (!overallWrapper) return
	if (document.querySelector('.cart-footer')) return
	const cartFooter = createElement('div', ['cart-footer'])
	// cartFooter.innerHTML = `
	// 	<div class="container">
	// 			<div class="secure-payment">
	// 				<span>Bezpečná platba</span>
	// 				<img src="/user/documents/upload/miranda/platebni_metody.png" width="180" height="20" alt="Visa, MasterCard, Maestro">
	// 			</div>
	// 			<div class="contact-box phone-wrapper"><span class="tel project-phone" itemprop="telephone" data-testid="contactboxPhone">

	//                 </span></div>
	// 			<div class="contact-box mail-wrapper">
	// 				<span>Odpovíme do druhého pracovního dne</span>
	// 			</div>
	// 		</div>
	// `
	if (dataLayer[0].shoptet.pageType === 'thankYou') {
		const projectPhone = document.querySelector('.project-phone')
		const projectMail = document.querySelector('.project-email')
		cartFooter.innerHTML = `
				<div class="container">
					<div class="secure-payment">
						<span>Bezpečná platba</span>
						<img src="/user/documents/upload/miranda/platebni_metody.png" width="180" height="20" alt="Visa, MasterCard, Maestro">
					</div>
					<div class="contact-box phone-wrapper add-icon">${projectPhone ? projectPhone.outerHTML : '+420 371 751 830'}${
			textKCislu ? `<span>${textKCislu}</span>` : ''
		}
					</div>
					<div class="contact-box mail-wrapper add-icon">${projectMail ? projectMail.outerHTML : 'tgs@tgs.cz'}${
			textKMailu ? `<span>${textKMailu}</span>` : ''
		}
					</div>
				</div>
		`
	} else {
		const mail = document.querySelector('.contact-box .mail')
		const tel = document.querySelector('.contact-box .tel')
		cartFooter.innerHTML = `
				<div class="container">
					<div class="secure-payment">
						<span>Bezpečná platba</span>
						<img src="/user/documents/upload/miranda/platebni_metody.png" width="180" height="20" alt="Visa, MasterCard, Maestro">
					</div>
					<div class="contact-box phone-wrapper">${tel ? tel.outerHTML : '+420 371 751 830'}${textKCislu ? `<span>${textKCislu}</span>` : ''}
					</div>
					<div class="contact-box mail-wrapper">${mail ? mail.outerHTML : 'tgs@tgs.cz'}${textKMailu ? `<span>${textKMailu}</span>` : ''}
					</div>
				</div>
		`
	}

	overallWrapper.appendChild(cartFooter)
	return cartFooter
}

/**
 * Create a cart popup summary - single price, total price, price without VAT, free shipping bar, and a button
 * @param {boolean} disableSinglePrice - Disable single price in the cart popup summary
 * @param {boolean} disablePriceWithoutVAT - Disable price without VAT in the cart popup summary
 */
const createCartPopupSummary = (disableSinglePrice = false, disablePriceWithoutVAT = false) => {
	document.addEventListener('ShoptetDOMCartContentLoaded', () => {
		const currencyLabel = dataLayer[0].shoptet.currencyInfo.symbol
		const cartWidgetProducts = document.querySelectorAll('.cart-widget-product')
		for (const product of cartWidgetProducts) {
			const productPrice = product.querySelector('span[data-testid="cartWidgetProductPrice"]')
			if (productPrice && !disableSinglePrice) {
				const priceEl = createElement('div', ['cart-widget-product-price'])
				priceEl.appendChild(productPrice)
				product.appendChild(priceEl)
				const productSKU = product.getAttribute('data-micro-sku')
				if (productSKU) {
					const productSinglePrice = dataLayer[0].shoptet.cart.filter((item) => item.code === productSKU)[0].priceWithVat
					const productSinglePriceEl = createElement('div', ['cart-widget-product-single-price'])
					productSinglePriceEl.innerHTML = `${productSinglePrice} ${currencyLabel} / ks`
					priceEl.appendChild(productSinglePriceEl)
				}
			}
		}
		let popupCartSummary = document.querySelector('.popup-cart-summary')
		if (!popupCartSummary) popupCartSummary = createElement('div', ['popup-cart-summary'])
		const popupCartSummaryPriveVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat
		const popupCartSummaryPriceNoVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat
		popupCartSummary.innerHTML = `
            <div class="popup-cart-summary-item">
                <strong class="popup-cart-summary-item-label">Celkem</strong>
                <strong class="popup-cart-summary-item-value">${popupCartSummaryPriveVAT} ${currencyLabel}</strong>
            </div>
            ${
				!disablePriceWithoutVAT
					? `
                        <div class="popup-cart-summary-item">
                            <span class="popup-cart-summary-item-label">Celkem bez DPH</span>
                            <span class="popup-cart-summary-item-value">${Math.round(popupCartSummaryPriceNoVAT)} ${currencyLabel}</span>
                        </div>`
					: ''
			}
		`
		const cartWidgetProductsWrapper = document.querySelector('.cart-widget-products')
		if (cartWidgetProductsWrapper)
			cartWidgetProductsWrapper.parentElement.insertBefore(popupCartSummary, cartWidgetProductsWrapper.nextElementSibling)

		const cartWidgetButton = document.querySelector('.cart-widget-button')
		const cartWidgetInner = document.querySelector('.cart-widget-inner')
		if (cartWidgetButton && cartWidgetInner) cartWidgetInner.appendChild(cartWidgetButton.cloneNode(true))

		const cartWidgetShipping = document.querySelector('.cart-free-shipping')
		if (cartWidgetShipping) {
			const priceLeftToFreeShipping = dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft
			if (priceLeftToFreeShipping > 0) {
				const freeShippingBar = createElement('div', ['price-range'])
				const freeShippingValue = createElement('div')
				freeShippingBar.appendChild(freeShippingValue)
				freeShippingValue.style.width = `${
					100 - (100 * priceLeftToFreeShipping) / (priceLeftToFreeShipping + popupCartSummaryPriveVAT)
				}%`
				cartWidgetShipping.appendChild(freeShippingBar)
			}
		}
	})
}

const makePriceTotalSeparateTd = () => {
	if (window.innerWidth > 768) {
		const removeables = document.querySelectorAll('.cart-table tr.removeable')
		for (const removeable of removeables) {
			const priceTotal = removeable.querySelector('.p-total .price-final')
			if (!priceTotal) return
			const pTotalSeparate = createElement('td', ['p-total-separate'])
			pTotalSeparate.appendChild(priceTotal)
			const pPrice = removeable.querySelector('.p-price')
			// if (pPrice) pPrice.before(pTotalSeparate)
			if (pPrice) pPrice.after(pTotalSeparate)
		}
	}
}

const freeShippingOnExtraDelivery = () => {
	const extraDelivery = document.querySelector('.extra.delivery span')
	if (extraDelivery) {
		if (dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft <= 0) extraDelivery.classList.add('for-free')
	}
}

const changeBtnToHeadingCheckoutBox = () => {
	const btn = document.querySelector('.btn.btn-block.btn-default.toggle-contacts')
	if (btn) {
		const heading = createElement('h4', ['heading'], btn.innerText.split('\n')[0])
		btn.replaceWith(heading)
	}
}

const handleStepBack = () => {
	const cartInner = document.querySelector('.cart-inner')
	const stepBack = document.querySelector('.next-step .next-step-back')
	const backShopping = document.querySelector('.back-shopping-link')
	if (cartInner) {
		if (backShopping) cartInner.appendChild(backShopping)
		if (stepBack) {
			if (window.innerWidth > 767) {
				cartInner.prepend(stepBack)
			} else if (backShopping) {
				backShopping.prepend(stepBack)
			}
			if (dataLayer[0].shoptet.pageType === 'billingAndShipping') {
				stepBack.innerHTML = window.language === 'cs' ? `<span>VRÁTIT SE O </span>KROK ZPĚT` : `<span>VRÁTIŤ SA O </span>KROK SPÄŤ`
			}
		}
	}
}

const changeTextInOrderBtn = (text) => {
	const orderBtn = document.querySelector('.next-step:not(.next-step--step-2) .order-button-text')
	if (orderBtn) orderBtn.innerText = text
}

// Gets information from end-point and if both succes and authorized are true, then displays payment option Platba na fakturu se splatností.
// In cart.scss (line around 1748) there is code which hides this payment option, as insurance if the end-point response is slow or script doesn't work.
// If the payment option is changed in Shoptet, the ID in the code has to be changed as well.
const getPaymentOnInvoice = async () => {
	const paymentOnInvoice = document.querySelector('.radio-wrapper[data-id="billing-62"]')
	const clientEmail = dataLayer[0].shoptet.customer.email
	const guid = dataLayer[0].shoptet.customer.guid
	if (!paymentOnInvoice || !clientEmail || !guid) return

	try {
		const response = await fetch('https://tgs-prod.axfone.eu/usercheck?mail=' + clientEmail + '&customer=' + guid)
		if (!response.ok) {
			throw new Error('Network response was not ok')
		}
		const data = await response.json()

		if (data.success && data.authorized) {
			paymentOnInvoice.style.display = 'block'
		} else {
			paymentOnInvoice.remove()
		}
		return data
	} catch (error) {
		console.error('Error fetching products data:', error)
		paymentOnInvoice.style.display = 'none'
		return null
	}
}

export {
	moveCartHeader,
	moveExtraDeliveryToSidebar,
	moveCouponFieldToSidebar,
	createCartFooter,
	createCartPopupSummary,
	makePriceTotalSeparateTd,
	freeShippingOnExtraDelivery,
	changeBtnToHeadingCheckoutBox,
	handleStepBack,
	changeTextInOrderBtn,
	getPaymentOnInvoice,
}
